<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="#003a6f"
            dark
            flat
            >
                <v-toolbar-title v-if="!drawer">{{ pageTitle }}</v-toolbar-title>
                <v-spacer v-if="!drawer"></v-spacer>
                <v-btn
                    color="primary"
                    @click="drawer = !drawer"
                    tile
                    v-if="!drawer"
                    >
                        <v-icon dark>mdi-menu</v-icon>
                </v-btn>
                <v-btn
                    color="primary"
                    @click="drawer = !drawer"
                    tile
                    v-else
                    large min-width="100%"
                    >
                        <v-icon dark>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
        </v-card>
        <v-card flat tile class="mx-auto overflow-hidden" min-height="calc(100vh - 112px)">
            <v-card flat tile>
                <v-list flat color="#004889" class="py-0" v-if="comments.length">
                    <v-list-item class="form-row" v-if="!comment.parent">
                        <v-list-item-content class="label">
                            <v-list-item-title class="white--text font-weight-bold">Category</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action class="justify-end">
                            <div class="d-flex align-center">
                                <v-select
                                    v-model="selectedCategory"
                                    :items="chat_categories"
                                    item-text="title"
                                    item-value="id"
                                    label="Category"
                                    hide-details
                                    solo
                                    flat
                                    dark
                                ></v-select>
                            </div>
                        </v-list-item-action>
                    </v-list-item>
                </v-list>
                <Comment v-for="(comment, index) in filteredComments" :key="index" :item="comment" @set-parent="replyComment"/>
                <v-card flat tile class="comment-form" color="accent">
                    <v-card-text class="pa-0">
                        <v-form ref="commentform">
                            <v-list flat color="#004889" class="py-0">
                                <v-list-item class="form-row">
                                    <v-list-item-content>
                                        <v-chip
                                        v-if="comment.parent"
                                        class="mb-3"
                                        close
                                        @click:close="comment.parent = null"
                                        small
                                        >
                                            Replying to: {{ activeComment | truncate(20, '...') }}
                                        </v-chip>
                                        <tiptap-vuetify
                                            class="mt-1"
                                            v-model="comment.comment"
                                            :extensions="extensions"
                                            placeholder=""
                                        />
                                        <v-checkbox
                                            v-model="comment.public"
                                            v-if="comment.parent == null"
                                            label="Make Public & Notify Customer"
                                            hide-details
                                            class="mt-1 public px-2"
                                            ripple="false"
                                            dark
                                        ></v-checkbox>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item class="form-row" v-if="!comment.parent">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="white--text font-weight-bold">Category</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action class="justify-end">
                                        <div class="d-flex align-center">
                                            <v-select
                                                v-model="comment.category"
                                                :items="formCategories"
                                                item-text="title"
                                                item-value="id"
                                                label="Category"
                                                hide-details
                                                solo
                                                flat
                                                dark
                                            ></v-select>
                                            <v-btn
                                                class="ml-1"
                                                fab
                                                dark
                                                small
                                                text
                                                @click="categoryDialog = !categoryDialog"
                                            >
                                                <v-icon dark>
                                                    mdi-plus
                                                </v-icon>
                                            </v-btn>
                                        </div>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list> 
                        </v-form>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="accent">
                        <v-spacer></v-spacer>
                        <v-btn large min-width="98%" color="white primary--text"  @click="sendComment" :loading="loading" tile>Comment</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>                 
                </v-card>
            </v-card>
            <Drawer :show="drawer" :id="id" :cid.sync="customer" @update-drawer="updateDrawer" />
            <AddCategory :dialog="categoryDialog" type="chat" @update-dialog="updateCategoryDialog" @update-categories="updateCategories"/>
            <v-dialog v-model="dialogConfirm" max-width="500px" persistent>
                <v-card color="primary">
                    <v-card-title class="subtitle-2 justify-center white--text">Are you sure to notify the customer?</v-card-title>
                    <v-card-actions class="accent">
                        <v-spacer></v-spacer>
                        <v-btn tile color="white darken-1" text @click="closeConfirm">No</v-btn>
                        <v-btn tile color="accent--text" @click="selectConfirm" :loading="loading">Yes</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card>
    </v-container>
</template>

<script>
    import axios from 'axios'
    import TokenService from '../../services/storage.service'
    import Drawer from './Drawer.vue'
    import Comment from '../../components/Comment.vue'
    import { mapActions } from 'vuex'
    import { TiptapVuetify, Link, Image } from 'tiptap-vuetify'
    import AddCategory from '../../components/AddCategory.vue'

    export default {
        props: ['id'],
        data () {
            return {
                comments: [], 
                customer: '',
                loading: false,
                token: '',
                pageTitle: '',
                drawer: false,
                comment: {
                    comment: '',
                    public: false,
                    parent: null,
                    type: 'comment',
                    category: ''
                },
                voptions: { "inline": false, "button": true, "navbar": false, "title": false, "toolbar": true, "tooltip": false, "movable": false, "zoomable": true, "rotatable": false, "scalable": false, "transition": false, "fullscreen": false, "keyboard": false, "url": "data-source" },
                // declare extensions you want to use
                extensions: [
                    Link,
                    Image,
                ],
                chat_categories: [],
                categoryDialog: false,
                selectedCategory: null,
                dialogConfirm: false
            }
        },
        watch: {
            'comment.parent': function(newVal) {
                if(newVal) {
                    this.comment.category = ''
                }
            },
            'comment.public': function(newVal) {
                if(newVal) {
                    this.dialogConfirm = true
                }
            }
        },
        created() {
            this.getChats()
            this.token = TokenService.getToken()
            this.pageTitle = this.$route.meta.title
        },
        components: {
            Drawer,
            Comment,
            TiptapVuetify,
            AddCategory
        },
        computed: {
            activeComment() {
                let active = this.comments.filter(comment => {
                    return comment.id == this.comment.parent
                })

                if(active.length > 0) {
                    return active[0].comment
                } else {
                    return ''
                }
            },
            filteredComments() {
                if(this.selectedCategory) {
                    return this.comments.filter(comment => {
                        return comment.category == this.selectedCategory
                    })
                } else {
                    return this.comments
                }
            },
            formCategories() {
                return this.chat_categories.filter(cat => {
                    return cat.id != ''
                })
            }
        },
        methods: {
            ...mapActions({
                addComment: 'data/addJobComment'
            }),
            getChats() {
                if(this.id) {
                    this.loading = true
                    axios.get('crm/job/comments?id=' + this.id)
                        .then((response) => {
                            this.loading = false
                            this.comments = response.data.comments
                            this.chat_categories = response.data.categories
                            this.customer = response.data.customer
                            this.$nextTick()
                        })
                }
            },
            async sendComment() {
                this.loading = true
                this.addComment({
                    id: this.id, 
                    comment: this.comment.comment, 
                    public: this.comment.public, 
                    parent: this.comment.parent,
                    type: this.comment.type,
                    category: this.comment.category
                }).then(response => {
                    this.getChats()
                    if(response.parent) {
                        let filteredComment = this.comments.filter(comment => {
                            return comment.id == response.parent
                        })

                        filteredComment[0].children.unshift(response)
                    } else {
                        this.comments.unshift(response)
                    }
                    this.comment.comment = ''
                    this.comment.public = false
                    this.comment.parent = null
                    this.$store.commit('SET_SNACKTYPE', 'green')
                    this.$store.commit('SET_SNACK', 'Successfully saved')
                }).catch(error => {
                    console.log(error)
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    this.$store.commit('SET_SNACK', 'Failed to save your comment! Please try again.')
                })
            },
            replyComment(parent, type) {
                this.comment.parent = parent
                this.comment.type = type
                const el = this.$el.getElementsByClassName('comment-form')[0]

                if (el) {
                    el.scrollIntoView({behavior: 'smooth'})                
                    this.$nextTick()
                }
            },
            updateDrawer(val) {
                this.drawer = val
            },
            updateCategoryDialog(val) {
                this.categoryDialog = val
            },
            updateCategories(val) {
                this.chat_categories.push(val)  
                this.comment.category = val.id
            },
            closeConfirm() {
                this.comment.public = false
                this.dialogConfirm = false
            },
            selectConfirm() {
                this.dialogConfirm = false
            }
        }
    }
</script>